function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .b {\r\n                fill: #ccc;\r\n            }\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M21.329,3.671A12.486,12.486,0,1,0,3.671,21.329,12.486,12.486,0,1,0,21.329,3.671ZM12.5,23.535A11.035,11.035,0,1,1,23.535,12.5,11.048,11.048,0,0,1,12.5,23.535Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M70.519,61a9.519,9.519,0,1,0,9.519,9.519A9.53,9.53,0,0,0,70.519,61Zm0,17.574a8.055,8.055,0,1,1,8.055-8.055A8.064,8.064,0,0,1,70.519,78.574Z",
  transform: "translate(-58.019 -58.019)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M186.863,125.239a.733.733,0,0,0,1.466,0,2.7,2.7,0,0,0-1.152-2.138,4.031,4.031,0,0,0-1.78-.731v-.79a.733.733,0,0,0-1.466,0v.79a4.03,4.03,0,0,0-1.78.731,2.561,2.561,0,0,0,0,4.277,4.031,4.031,0,0,0,1.78.731v2.9c-.844-.206-1.466-.753-1.466-1.377a.733.733,0,0,0-1.466,0,2.7,2.7,0,0,0,1.152,2.138,4.031,4.031,0,0,0,1.78.731v.8a.733.733,0,0,0,1.466,0v-.8a4.03,4.03,0,0,0,1.78-.731,2.561,2.561,0,0,0,0-4.277,4.031,4.031,0,0,0-1.78-.731v-2.9C186.242,124.068,186.863,124.615,186.863,125.239Zm-4.4,0c0-.623.622-1.171,1.466-1.377v2.753C183.087,126.409,182.466,125.862,182.466,125.239Zm4.4,4.392c0,.623-.622,1.171-1.466,1.377v-2.753C186.242,128.46,186.863,129.007,186.863,129.631Z",
  transform: "translate(-172.165 -114.942)"
});

var SvgCoin = function SvgCoin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coin.5533c3d1.svg";
export { ForwardRef as ReactComponent };